import {
  checkboxUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import FieldsetLabel from '../../../components/FormDescriptions/FieldsetLabel';
import DemographicField from '../../../components/FormReview/DemographicReviewField';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info--demographic-info-title'];
const DESC_TEXT = content['vet-info--demographic-info-description'];
const FIELDSET_LABEL = content['vet-info--demographic-info-label'];
const INPUT_LABELS = {
  indian: content['vet-info--demographic-info-indian-label'],
  latino: content['vet-info--demographic-info-latino-label'],
  asian: content['vet-info--demographic-info-asian-label'],
  black: content['vet-info--demographic-info-black-label'],
  hawaiian: content['vet-info--demographic-info-hawaiian-label'],
  white: content['vet-info--demographic-info-white-label'],
  na: content['vet-info--demographic-info-no-answer-label'],
};

const {
  isAmericanIndianOrAlaskanNative,
  isAsian,
  isBlackOrAfricanAmerican,
  isNativeHawaiianOrOtherPacificIslander,
  isSpanishHispanicLatino,
  isWhite,
  hasDemographicNoAnswer,
} = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    'view:demographicCategories': {
      'ui:title': FieldsetLabel(FIELDSET_LABEL),
      'ui:reviewField': DemographicField,
      isAmericanIndianOrAlaskanNative: checkboxUI(INPUT_LABELS.indian),
      isSpanishHispanicLatino: checkboxUI(INPUT_LABELS.latino),
      isAsian: checkboxUI(INPUT_LABELS.asian),
      isBlackOrAfricanAmerican: checkboxUI(INPUT_LABELS.black),
      isNativeHawaiianOrOtherPacificIslander: checkboxUI(INPUT_LABELS.hawaiian),
      isWhite: checkboxUI(INPUT_LABELS.white),
      hasDemographicNoAnswer: checkboxUI(INPUT_LABELS.na),
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:demographicCategories': {
        type: 'object',
        properties: {
          isAmericanIndianOrAlaskanNative,
          isAsian,
          isBlackOrAfricanAmerican,
          isSpanishHispanicLatino,
          isNativeHawaiianOrOtherPacificIslander,
          isWhite,
          hasDemographicNoAnswer,
        },
      },
    },
  },
};
